import escapeRegExp from './escapeRegExp';

/**
 * This helper function case-insensitively finds a pattern in a string.
 * @param {string} pattern pattern to look for in string
 */
export const findString = (pattern: string) => (inputStr?: string): boolean => {
  // Look in the entire input string (g flag for global) for pattern,
  // without paying attention to casing (i flag for insensitive).
  const re = new RegExp(escapeRegExp(pattern), 'gi');
  return !inputStr ? false : re.test(inputStr);
};
